export const DEFAULT_LAT = 41.9028;
export const DEFAULT_LNG = 12.4964;
export const DEFAULT_ZOOM = 17;
export const EUROPE_CENTER = { lat: 45.4642, lng: 9.1900 };
export const EUROPE_ZOOM = 5;